export const baseColors = {
    onyx: '#000000',
    pearl: '#FFFFFF',
    keshi: '#777777',
    moon: '#E5E5E5',
    tahitian: '#F5F5F5',
    smoke: '#1E1E1E',
    dust: '#404040',
    ghost: '#F1F0F5',
    stone: '#A1A1A9',
} as const

export const opacityOnyx = {
    onyx12: '#00000012',
    onyx30: '#00000030',
    onyx50: '#00000050',
    onyx70: '#00000070',
    onyx90: '#00000090',
} as const

export const opacitySmoke = {
    smoke12: '#1E1E1E1F',
    smoke30: '#1E1E1E4D',
    smoke50: '#1E1E1E80',
    smoke70: '#1E1E1EB3',
} as const
export const opacityKeshi = {
    keshi12: '#7777771F',
    keshi30: '#7777774D',
    keshi50: '#77777780',
    keshi70: '#777777B3',
} as const
export const opacityMoon = {
    moon12: '#E5E5E512',
    moon30: '#E5E5E530',
    moon50: '#E5E5E550',
    moon70: '#E5E5E570',
} as const
export const opacityGhost = {
    ghost12: '#F1F0F512',
    ghost30: '#F1F0F530',
    ghost50: '#F1F0F550',
    ghost70: '#F1F0F570',
} as const
export const opacityStone = {
    stone12: '#A1A1A912',
    stone30: '#A1A1A930',
    stone50: '#A1A1A950',
    stone70: '#A1A1A970',
} as const

export const opacityPearl = {
    pearl12: '#FFFFFF12',
    pearl30: '#FFFFFF30',
    pearl50: '#FFFFFF50',
    pearl70: '#FFFFFF70',
    pearl90: '#FFFFFF90',
} as const
export const opacityLemon = {
    lemon70: '#CFFF04B3',
    lemon50: '#CFFF0480',
    lemon20: '#CFFF0433',
} as const
export const opacityKiwi = {
    kiwi70: '#8DED27B3',
    kiwi50: '#8DED2780',
    kiwi20: '#8DED2733',
} as const
export const opacityMalachite = {
    malachite70: '#00E164B3',
    malachite50: '#00E16480',
    malachite20: '#00E16433',
} as const
export const opacityTurquoise = {
    turquoise70: '#00FFB8B3',
    turquoise50: '#00FFB880',
    turquoise20: '#00FFB833',
} as const
export const opacityPacific = {
    pacific70: '#00B1BBB3',
    pacific50: '#00B1BB80',
    pacific20: '#00B1BB33',
} as const
export const opacityCyan = {
    cyan70: '#49CFE8B3',
    cyan50: '#49CFE880',
    cyan20: '#49CFE833',
} as const
export const opacitySky = {
    sky70: '#106BFEB3',
    sky50: '#106BFE80',
    sky20: '#106BFE33',
} as const
export const opacityPurple = {
    purple70: '#5B1CE7B3',
    purple50: '#5B1CE780',
    purple20: '#5B1CE733',
} as const
export const opacityViolet = {
    violet70: '#B31EFFB3',
    violet50: '#B31EFF80',
    violet20: '#B31EFF33',
} as const
export const opacityPink = {
    pink70: '#FF3B80B3',
    pink50: '#FF3B8080',
    pink20: '#FF3B8033',
} as const
export const opacityRaspberry = {
    raspberry70: '#FF004AB3',
    raspberry50: '#FF004A80',
    raspberry20: '#FF004A33',
} as const
export const opacityOrange = {
    orange70: '#FF7B3AB3',
    orange50: '#FF7B3A80',
    orange20: '#FF7B3A33',
} as const

export const opacityColors = {
    ...opacityOnyx,
    ...opacitySmoke,
    ...opacityKeshi,
    ...opacityMoon,
    ...opacityPearl,
    ...opacityGhost,
    ...opacityStone,
    ...opacityLemon,
    ...opacityKiwi,
    ...opacityMalachite,
    ...opacityTurquoise,
    ...opacityPacific,
    ...opacityCyan,
    ...opacitySky,
    ...opacityPurple,
    ...opacityViolet,
    ...opacityPink,
    ...opacityRaspberry,
    ...opacityOrange,
} as const

export const highlightColors = {
    lemon: '#CFFF04',
    kiwi: '#8DED27',
    malachite: '#00E164',
    turquoise: '#00FFB8',
    pacific: '#00B1BB',
    cyan: '#49CFE8',
    sky: '#106BFE',
    purple: '#5B1CE7',
    violet: '#B31EFF',
    pink: '#FF3B80',
    raspberry: '#FF004A',
    orange: '#FF7B3A',
} as const

export const leagueQualifierColors = {
    yellow: '#FEDE00',
    lightgreen: '#32CD30',
    green: '#0A7029',
    lightblue: '#4285F4',
    blue: '#003F94',
    Red: '#F51720',
} as const

const colorPattern = {
    ...baseColors,
    ...opacityColors,
    ...highlightColors,
    ...leagueQualifierColors,
} as const
export default colorPattern
